import axios from "axios";
import {
  updateApplicationEditData,
  updateApplicationStatus
} from "scenes/Application/ApplicationEdit/applicationEdit";
import deployMarketAppPage from "scenes/Application/DeployMarketApp/DeployMarketAppPage";

// const
const REDIRECT_TO_DEPLOY_MARKET_APP = "deployMarketApp/REDIRECT_TO_DEPLOY_MARKET_APP";
const DEPLOY_MARKET_APP_STORE_APP_VERSION = "deployMarketApp/DEPLOY_MARKET_APP_STORE_APP_VERSION";
const DEPLOY_MARKET_APP_STORE_APP_PLAN = "deployMarketApp/DEPLOY_MARKET_APP_STORE_APP_PLAN";
const DEPLOY_MARKET_APP_STORE_APP_TYPES = "deployMarketApp/DEPLOY_MARKET_APP_STORE_APP_TYPES";
const DEPLOY_MARKET_APP_STORE_SPACES = "deployMarketApp/DEPLOY_MARKET_APP_STORE_SPACES";
const DEPLOY_MARKET_APP_STORE_DOMAINS = "deployMarketApp/DEPLOY_MARKET_APP_STORE_DOMAINS";
const DEPLOY_MARKET_APP_UPDATE_DATA = "deployMarketApp/DEPLOY_MARKET_APP_UPDATE_DATA";
const DEPLOY_MARKET_APP_TOGGLE_LOADING = "deployMarketApp/DEPLOY_MARKET_APP_TOGGLE_LOADING";
const DEPLOY_MARKET_APP_TOGGLE_UPDATING = "deployMarketApp/DEPLOY_MARKET_APP_TOGGLE_UPDATING";
const DEPLOY_MARKET_APP_STORE_APPLICATION = "deployMarketApp/DEPLOY_MARKET_APP_STORE_APPLICATION";
const DEPLOY_MARKET_STORE_NAMESPACES = "deployMarketApp/DEPLOY_MARKET_STORE_NAMESPACES";
const DEPLOY_MARKET_MODAL_SUCCESS_TITLE = "deployMarketApp/DEPLOY_MARKET_MODAL_SUCCESS_TITLE";
const DEPLOY_MARKET_MODAL_DEPLOY_SUCCESS_CONTENT = "deployMarketApp/DEPLOY_MARKET_MODAL_DEPLOY_SUCCESS_CONTENT";
const DEPLOY_MARKET_MODAL_YES_LABEL = "deployMarketApp/DEPLOY_MARKET_MODAL_YES_LABEL";
const DEPLOY_MARKET_MODAL_NO_LABEL = "deployMarketApp/DEPLOY_MARKET_MODAL_NO_LABEL";
const DEPLOY_MARKET_MODAL_FAIL_TITLE = "deployMarketApp/DEPLOY_MARKET_MODAL_FAIL_TITLE";
const DEPLOY_MARKET_MODAL_DEPLOY_FAIL_CONTENT = "deployMarketApp/DEPLOY_MARKET_MODAL_DEPLOY_FAIL_CONTENT";
const DEPLOY_MARKET_MODAL_OK_LABEL = "deployMarketApp/DEPLOY_MARKET_MODAL_OK_LABEL";
const DEPLOY_MARKET_MODAL_RETURN_LABEL = "deployMarketApp/DEPLOY_MARKET_MODAL_RETURN_LABEL";
const DEPLOY_MARKET_STORE_APP_INFO = "deployMarketApp/DEPLOY_MARKET_STORE_APP_INFO";
const DEPLOY_MARKET_TOGGLE_MODAL = "deployMarketApp/DEPLOY_MARKET_TOGGLE_MODAL";
const DEPLOY_MARKET_APP_ACCOUNT = "deployMarketApp/DEPLOY_MARKET_APP_ACCOUNT";

// null modal content const
const DEPLOY_MARKET_APP_NULL_MODAL_CONTENT_SPACE = "deployMarketAppNullModalContentSpace";
const DEPLOY_MARKET_APP_NULL_MODAL_CONTENT_VISIT_LINK = "deployMarketAppNullModalContentVisitLink";
const DEPLOY_MARKET_APP_NULL_MODAL_CONTENT_DOMAIN = "deployMarketAppNullModalContentDomain";

Date.prototype.formatByMonth = function (fmt, monthNum) {
  if (monthNum) {
    this.setMonth(this.getMonth() + monthNum);
  }
  let o = {
    "M+": this.getMonth() + 1,                    //月份
    "d+": this.getDate(),                         //日
    "h+": this.getHours(),                        //小时
    "m+": this.getMinutes(),                      //分
    "s+": this.getSeconds(),                      //秒
    "q+": Math.floor((this.getMonth() + 3) / 3),  //季度
    "S": this.getMilliseconds()                   //毫秒
  };
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
  }
  for (let k in o) {
    if (new RegExp("(" + k + ")").test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    }
  }
  return fmt;
};

// reducer
export const deployMarketApp = (state = {

  loading: false,
  updating: false,

  // applicationId: "",
  appVersionId: "",
  appPlanId: "",
  appPeriodId: "",
  periods: "",
  users: "",

  appVersion: [],
  spaces: [],
  deployTitle: "",
  spaceId: "",
  diskQuota: "",
  memoryQuota: "",
  randomRoute: false,
  runtimeStart: "",
  runtimeEnd: "",

  application: "",
  cost: "",
  namespace: "",
  appInfo: "",
  balance: "",
  majorId: "",

  modalVisible: false,
  modalTitle: "",
  modalContent: "",
  modalVisitUrl: null,
  modalOk: "",
  modalCancel: "",
  onOk: null,
  onCancel: null

}, action) => {
  switch (action.type) {
    case REDIRECT_TO_DEPLOY_MARKET_APP:
      return {
        ...state,
        // applicationId: action.data.applicationId,
        appVersionId: action.data.versionId,
        appPlanId: action.data.planId,
        appPeriodId: action.data.periodId
      };
    case DEPLOY_MARKET_APP_STORE_APP_VERSION:
      return {
        ...state,
        appVersion: action.data
      };
    case DEPLOY_MARKET_APP_STORE_APP_PLAN:
      return {
        ...state,
        diskQuota: action.data.applicationPlanItems.map(item => {
          if (item.item === "DISK_QUOTA")
            return parseInt(item.value)
        }),
        memoryQuota: action.data.applicationPlanItems.map(item => {
          if (item.item === "MEMORY_QUOTA")
            return parseInt(item.value)
        })
      };
    case DEPLOY_MARKET_APP_STORE_SPACES:
      return {
        ...state,
        spaces: action.data
      };
    case DEPLOY_MARKET_APP_UPDATE_DATA:
      return {
        ...state,
        [action.data.name]: action.data.value
      };
    case DEPLOY_MARKET_APP_TOGGLE_LOADING:
      return {
        ...state,
        loading: action.data
      };
    case DEPLOY_MARKET_APP_TOGGLE_UPDATING:
      return {
        ...state,
        updating: action.data
      };
    case DEPLOY_MARKET_APP_STORE_APPLICATION:
      return{
        ...state,
        application: action.data
      };
    case DEPLOY_MARKET_STORE_NAMESPACES:
      return {
        ...state,
        namespace: action.data
      };
    case DEPLOY_MARKET_STORE_APP_INFO:
      return {
        ...state,
        appInfo: action.data
      };
    case DEPLOY_MARKET_TOGGLE_MODAL:
      return {
        ...state,
        modalVisible: action.data.modalVisible,
        modalTitle: action.data.modalTitle,
        modalContent: action.data.modalContent,
        modalVisitUrl: action.data.modalVisitUrl || null,
        modalOk: action.data.modalOk,
        modalCancel: action.data.modalCancel,
        onOk: action.data.onOk,
        onCancel: action.data.onCancel
      };
    case DEPLOY_MARKET_APP_ACCOUNT:
      return {
        ...state,
        balance: action.data
      }
    default:
      return state
  }
};

/**
 * 前页跳转此页，需要传递参数：versionedApp.id、appPlan.id
 */
export function redirectToDeployMarketAppPage(data) {
  return {
    type: REDIRECT_TO_DEPLOY_MARKET_APP,
    data: data
  };
}

/**
 * check and get versionedApp、appPlan
 */
export const initDeploy = (data) => (dispatch) => {
  let appVersionId = data.appVersionId;
  let enterpriseId = data.enterprise;
  if (appVersionId !== "") {
    dispatch(toggleLoading(true));
    axios.get(`/api-application/getVersionById/`+ `${appVersionId}`, {contentType: "application/json"}).then(
      response => {
        dispatch(storeAppVersion(response.data));
        dispatch(storeApplication(response.data.majorVersion.application))
        console.log(response.data);
        dispatch(toggleLoading(false));
        dispatch(updateDeployMarketAppData({
          name: "majorId",
          value: response.data.majorVersion.id
        }));
      }
    );
    let appPlanId = data.appPlanId;
    if (appPlanId !== null && appPlanId !== undefined && appPlanId !== "") {
      axios.get(`/api-application/getApplicationPlanItemsByApplicationPlanId?applicationPlanId=${appPlanId}`, {contentType: "application/json"}).then(
        response => {
          if (response.data) {
            response.data.map(item => {
              if (item.item === "DISK_QUOTA") {
                dispatch(updateDeployMarketAppData({
                  name: "diskQuota",
                  value: parseInt(item.value)
                }));
              } else if (item.item === "MEMORY_QUOTA") {
                dispatch(updateDeployMarketAppData({
                  name: "memoryQuota",
                  value: parseInt(item.value)
                }));
              } else {
                return null;
              }
            });
            // dispatch(storeAppPlan(response.data));
            dispatch(toggleLoading(false));
          }
        }
      );
    }

    let periods = data.periods;
    if (periods !== null && periods !== undefined && periods !== "") {
      dispatch(updateDeployMarketAppData({
        name: "periods",
        value: periods
      }));
      let currentTime = new Date();
      dispatch(updateDeployMarketAppData({
        name: "runtimeStart",
        value: currentTime.formatByMonth('yyyy-MM-dd hh:mm:ss', 0)
      }));
      dispatch(updateDeployMarketAppData({
        name: "runtimeEnd",
        value: currentTime.formatByMonth('yyyy-MM-dd hh:mm:ss', parseInt(periods))
      }));
    }

    let users = data.users;
    if (users !== null && users !== undefined && users !== "") {
      dispatch(updateDeployMarketAppData({
        name: "users",
        value: users
      }));
    }

    let cost = data.cost;
    if (cost !== null && cost !== undefined && cost !== "") {
      dispatch(updateDeployMarketAppData({
        name: "cost",
        value: cost
      }));
    }

    axios.get("/api-tenant/namespace/getNamespace/" +`00000000-0000-0000-0000-000000000000`, {contentType: "application/json"}).then(
      // axios.get("/api-tenant/namespace/getNamespaces/" +`${enterpriseId}`, {contentType: "application/json"}).then(
      response => {
        if (response.data) {
          dispatch(storeNamespaces(response.data));
        }
      }
    );
    dispatch(toggleLoading(false));
  } else {
    // browserHistory.push("/appMarket");
  }
};

/**
 * store single app version
 */
export const storeAppVersion = (appVersion) => {
  return {
    type: DEPLOY_MARKET_APP_STORE_APP_VERSION,
    data: appVersion
  }
};

/**
 * store single app plan
 */
export const storeAppPlan = (appPlan) => {
  return {
    type: DEPLOY_MARKET_APP_STORE_APP_PLAN,
    data: appPlan
  }
};


/**
 * get all app spaces
 */
export const getSpaces = (enterprise) => (dispatch) => {
  if (enterprise !== "" && enterprise !== null) {
    dispatch(toggleUpdating(true));
    axios.get(`/api-tenant/org/spaces/enterprise/?enterprise-code=${enterprise}`, {contentType: "application/json"}).then(
      response => {
        if (response.data) {
          dispatch(storeSpaces(response.data));
        } else {
          dispatch(storeSpaces([]));
        }
        dispatch(toggleUpdating(false));
      }
    );
  } else {
    dispatch(storeSpaces([]));
  }

};

/**
 * store all app spaces
 */
export const storeSpaces = (spaces) => {
  return {
    type: DEPLOY_MARKET_APP_STORE_SPACES,
    data: spaces
  }
};

/**
 * update data based on user input
 */
export const updateDeployMarketAppData = (data) => {
  return {
    type: DEPLOY_MARKET_APP_UPDATE_DATA,
    data: data
  }
};

/**
 * submit data
 */
export const deployApplication = (data, history) => (dispatch) => {
  dispatch(toggleLoading(true));

  let headers = new Headers();
  // headers.append("Content-Type", "application/json");
  headers.append("Accept", 'application/json, application/xml, text/plain, text/html, *.*');
  let month = parseInt(data.month);
  let url = `/api-tenant/app/buy?appId=` + data.applicationId+ "&majorId=" + data.majorId +
    "&minorId=" + data.minorId + "&enterpriseId=" + data.enterpriseId + "&other=" + data.other + "&month=" + month;
      axios({
        method: "POST",
        url: url,
        contentType: "application/json",
        data: {
          host: data.host,
          port: data.port,
          database: data.database,
          username: data.username,
          password: data.password,
          // account: response.data.account,
        },
      }).then(
    response => {
      console.log(response);
      if (response.status === 200) {
        dispatch(toggleLoading(false));
        console.log("success deploy application");
        // axios(`/api-user/enterprise?id=${data.enterpriseId}`).then(
        axios(`/api-user/users?userId=${data.userId}`).then(
          response => {
            axios({
              method: "POST",
              url: `/api-account/executePayment`,
              contentType: "application/json",
              data: {
                cost: data.cost,
                userId: data.userId,
                // account: "300",
                account: response.data.account,
              },
            }).then(
              response => {
                if (response.status === 200) {
                  dispatch(storeAccount(response.balance));
                  dispatch(toggleModal({
                    modalVisible: true,
                    modalTitle: "成功",
                    modalContent: "应用购买成功，账户余额为" + response.data.balance + "元",
                    modalVisitUrl: null,
                    modalOk: "菜单配置",
                    modalCancel: "查看应用",
                    onOk: () => {
                      dispatch(toggleModal({
                        modalVisible: false
                      }));
                      history.push(`/console/menu-management`);
                    },
                    onCancel: () => {
                      dispatch(toggleModal({
                        modalVisible: false
                      }));
                      history.push(`/console/space-apps-management`);
                    }
                  }));
                }
              }
            );
          })
        // return response.text();
      } else {
        // dispatch(showFailModal(true));
        alert("部署失败");
        dispatch(toggleLoading(false));
        console.log("fail to deploy application");
      }
    }
  );
  // axios({
  //   url: `/api-tenant/app/deploy/`,
  //   headers: headers,
  //   method: "POST",
  //   data: formData,
  // }).then(
  //   response => {
  //     alert(response.status);
  //     if (response.status === 200) {
  //       alert(response.data);
  //       dispatch(toggleLoading(false));
  //       console.log("success deploy application");
  //       // return response.text();
  //     } else {
  //       // dispatch(showFailModal(true));
  //       alert("部署失败");
  //       dispatch(toggleLoading(false));
  //       console.log("fail to deploy application");
  //     }
  //   }
  // );
};

// /**
//  * toggle modal
//  */
// export const toggleModal = (show) => {
//   return {
//     type: DEPLOY_MARKET_APP_TOGGLE_MODAL,
//     data: show
//   }
// };


/**
 * toggle loading
 */
export const toggleLoading = (show) => {
  return {
    type: DEPLOY_MARKET_APP_TOGGLE_LOADING,
    data: show
  }
};

/**
 * toggle updating
 */
export const toggleUpdating = (show) => {
  return {
    type: DEPLOY_MARKET_APP_TOGGLE_UPDATING,
    data: show
  }
};

export function storeApplication(data) {
  return {
    type: DEPLOY_MARKET_APP_STORE_APPLICATION,
    data: data
  };
}

/**
 * find appInfo
 */
export const findAppInfo = (data) => (dispatch) => {
  dispatch(toggleLoading(true));
  axios({
    method: "POST",
    url: `/api-tenant/app/findAppInfo`,
    data: data,
  }).then(
    response => {
      dispatch(toggleLoading(false));
      if (response.status === 200 && response.data) {
        console.info("success find appInfo");
        dispatch(storeAppInfo(response.data));
        // dispatch(updateApplicationEditData({
        //   name: "docker",
        //   value: response.data.dockerUrl
        // }));
      } else {
        console.warn("no find appInfo");
        dispatch(storeAppInfo({
          jarUrl: "",
          dockerUrl: ""
        }));
        // dispatch(updateApplicationEditData({
        //   name: "docker",
        //   value: ""
        // }));
      }
    }
  ).catch(
    err => {
      dispatch(toggleLoading(false))
      console.error("fail to find docker", err);
      dispatch(updateApplicationEditData({
        name: "docker",
        value: ""
      }));
    }
  );
};


/**
 * store appInfo
 */
export const storeAppInfo = (appInfo) => {
  return {
    type: DEPLOY_MARKET_STORE_APP_INFO,
    data: appInfo
  }
};

/**
 * submit deploy
 */
export const submitDeploy = (data) => (dispatch) => {
  dispatch(toggleLoading(true));
  axios({
    method: "POST",
    url: `/api-tenant/app/deploy`,
    data: data,
  }).then(
    response => {
      dispatch(toggleLoading(false));
      if (response.status === 200) {
        console.info("success deploy application");
        let deploymentId = response.data;
        // if (!data.containerPort) {//外网应用需要应用壳授权
        //   axios({
        //     url: `/api-shell/insertMenu`,
        //     method: "POST",
        //     data: {
        //       "other": data.other,
        //       "deploymentId": deploymentId,
        //       "name": data.name,
        //       "path": data.path || "",
        //       "sortId": data.sortId,
        //       "privilege": data.privilege,
        //     }
        //   })
        // }
        dispatch(updateApplicationEditData({
          name: "versionVisible",
          value: false
        }));
        dispatch(toggleModal({
          modalVisible: true,
          modalTitle: DEPLOY_MARKET_MODAL_SUCCESS_TITLE,
          modalContent: DEPLOY_MARKET_MODAL_DEPLOY_SUCCESS_CONTENT,
          modalVisitUrl: response.data,
          modalOk: DEPLOY_MARKET_MODAL_YES_LABEL,
          modalCancel: DEPLOY_MARKET_MODAL_NO_LABEL,
          onOk: () => {
            dispatch(toggleModal({
              modalVisible: false
            }));
          },
          onCancel: () => {
            dispatch(toggleModal({
              modalVisible: false
            }));
          }
        }));
      } else {
        console.error("fail to deploy application");
        dispatch(toggleModal({
          modalVisible: true,
          modalTitle: DEPLOY_MARKET_MODAL_FAIL_TITLE,
          modalContent: DEPLOY_MARKET_MODAL_DEPLOY_FAIL_CONTENT,
          modalVisitUrl: null,
          modalOk: DEPLOY_MARKET_MODAL_OK_LABEL,
          modalCancel: DEPLOY_MARKET_MODAL_RETURN_LABEL,
          onOk: () => {
            dispatch(toggleModal({
              modalVisible: false
            }))
          },
          onCancel: () => {
            dispatch(toggleModal({
              modalVisible: false
            }))
          }
        }));
      }
    }
  );
};

/**
 * get  namespace
 */
export const getNamespaces = () => (dispatch) => {
  dispatch(toggleLoading(true));
  axios.get("/api-tenant/namespace/getNamespaces/" +`00000000-0000-0000-0000-000000000000`, {contentType: "application/json"}).then(
  // axios.get("/api-tenant/namespace/getNamespaces/" +`${this.props.enterprise}`, {contentType: "application/json"}).then(
    response => {
      if (response.data) {
        dispatch(storeNamespaces(response.data));
        dispatch(toggleLoading(false));
      }
    }
  );
};

/**
 * store  namespace
 */
export const storeNamespaces = (namespaces) => {
  return {
    type: DEPLOY_MARKET_STORE_NAMESPACES,
    data: namespaces
  }
};

export const toggleModal = (show) => {
  return {
    type: DEPLOY_MARKET_TOGGLE_MODAL,
    data: show
  }
};

export const storeAccount = (data) => {
  return {
    type: DEPLOY_MARKET_APP_ACCOUNT,
    data: data
  }
};
